import BaseView from './BaseView';
import BecomeMember from '../../components/BecomeMember';
import Modal from '../../components/Modal';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let view = null;

class Join extends BaseView {
	constructor(container) {
		super(container);

		this.topSection = this.container.querySelector('[data-join-top]');
		this.bottomSection = this.container.querySelector('[data-join-bottom]');
	}

	init() {

		new Modal();

		this.container.querySelectorAll('[data-join-bam]').forEach((el) => {
			this.modules.push(new BecomeMember(el));
		});

		this.container.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const link = e.target?.closest('[data-scroll-to]');

			if (!link) {
				return;
			}

			e.preventDefault();

			const selector = link.dataset.scrollTo ? link.dataset.scrollTo : link.hash;

			if (!selector) {
				return;
			}

			gsap.to(window, {
				duration: 1.4,
				ease: 'power2.inOut',
				scrollTo: {
					y: selector,
					offsetY: document.querySelector('.c-header [data-main]').offsetHeight,
				},
			});
		});

		// Calculate the height op the top section on resize
		this.boundCalculateTopPartHeight = this.calculateTopPartHeight.bind(this);
		window.addEventListener('resize', this.boundCalculateTopPartHeight);
		this.calculateTopPartHeight();

		this.setupScrolling();


		// Scroll to target Section when clicking Nav Menu (while alreay on campus)
        this.navLinks = document.querySelectorAll('[data-join-nav-link]');
		this.boundHandleNavClick = this.handleNavClick.bind(this);
        this.navLinks.forEach(link => {
			link.addEventListener('click', this.boundHandleNavClick);
		});
	}

	setupScrolling() {
		// Animate the top overlay during a part of the bottom section scroll duration
		gsap.to(this.topSection.querySelector('[data-join-top-overlay]'), {
			opacity: 1,
			scrollTrigger: {
				trigger: this.bottomSection,
				start: () => {
					return `top-=${window.innerHeight - window.innerHeight * 1} bottom`;
				},
				end: () => {
					return `+=${window.innerHeight}`;
				},
				scrub: true,
			},
		});
	}

	calculateTopPartHeight() {
		// Set sticky position of top section as css variable
		this.topSection.style.setProperty(
			'--sticky-top',
			(this.topSection.clientHeight - document.documentElement.clientHeight) * -1 + 'px'
		);
	}


	scrollToSection(targetID, duration = 0) {
		const targetSection = this.container.querySelector(targetID);

		gsap.to(window, {
			duration: duration,
			ease: 'power2.inOut',
			scrollTo: {
				y: targetSection,
				offsetY: document.querySelector('.c-header [data-main]').offsetHeight+10,
			},
		});
	}

	destroy() {
		super.destroy();

		window.removeEventListener('resize', this.boundCalculateTopPartHeight);
	}
}

export default {
	namespace: 'template-join',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Join(next.container);
		view.init();
	},
	afterEnter: ({ current, next, trigger, four }) => {
        view.afterEnterFunctions();
    },
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
